export default __webpack_public_path__ + "static/media/640_private03-it-mobile.6162611b.png";